import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const createUser = createAsyncThunk(
    'user/create',
    async (post_data: any, { rejectWithValue }) => {

        const createURL = `${URL_API}/supplier-portal/accounts`;

        try {
            const { data } = await axios.post<ResetResult>(createURL, post_data, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);